export default "__VITE_ASSET__Bv5kifhq__"